module.exports = new __parcel__URL__("hierarchy-tasks-with-background-light.7076b893.svg").toString();